import {
  COARSE_MQ,
  coarsePointer,
  emitSimCamPlace,
  getMapTool,
  MAP_TOOLS,
  setMapTool,
  walkPlaceFromClick,
} from "./sim_cam_geo.js"

function stop(event) {
  event.stopPropagation()
}

/** Leaflet Draggable on the disc listens to touchstart, not only mousedown. */
export function bindCamDiscTouchStop(root) {
  if (!root || typeof root.querySelectorAll !== "function") return () => {}
  const bound = new Set()
  const bind = (node) => {
    if (!node || bound.has(node)) return
    bound.add(node)
    node.addEventListener("touchstart", stop)
    node.addEventListener("mousedown", stop)
  }
  root.querySelectorAll(".pin-sim-cam").forEach(bind)
  const mo = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType !== 1) continue
        if (typeof node.matches === "function" && node.matches(".pin-sim-cam")) bind(node)
        if (typeof node.querySelectorAll === "function") {
          node.querySelectorAll(".pin-sim-cam").forEach(bind)
        }
      }
    }
  })
  mo.observe(root, {childList: true, subtree: true})
  return () => {
    mo.disconnect()
    for (const node of bound) {
      node.removeEventListener("touchstart", stop)
      node.removeEventListener("mousedown", stop)
    }
    bound.clear()
  }
}

export function wrapPinMapForTouch(PinMap) {
  return {
    ...PinMap,
    mounted() {
      PinMap.mounted.call(this)
      if (!this.map || this.el.dataset.interactive === "false") return
      if (this.el.dataset.mapTools === "true" && coarsePointer()) {
        if (getMapTool(this.el) == null) setMapTool(this.el, "pan")
        const dbl = this.map.doubleClickZoom
        if (dbl && typeof dbl.disable === "function") dbl.disable()
      }
      this._onWalkClick = (event) => {
        if (getMapTool(this.el) !== "walk") return
        if (this.camDragging) return
        const origin = typeof this.pinOrigin === "function" ? this.pinOrigin() : null
        if (!origin) return
        const en = walkPlaceFromClick(event, origin.lat, origin.lng)
        if (en) emitSimCamPlace(en)
      }
      this.map.on("click", this._onWalkClick)
      this._unbindCamTouch = bindCamDiscTouchStop(this.el)
    },
    destroyed() {
      if (this.map && this._onWalkClick) this.map.off("click", this._onWalkClick)
      if (this._unbindCamTouch) this._unbindCamTouch()
      setMapTool(this.el, null)
      PinMap.destroyed.call(this)
    },
  }
}

function syncPressed(root, tool) {
  for (const btn of root.querySelectorAll("[data-map-tool]")) {
    btn.setAttribute("aria-pressed", btn.dataset.mapTool === tool ? "true" : "false")
  }
}

export const MapTools = {
  mounted() {
    this.tool = "pan"
    this.mapEl = document.getElementById(this.el.dataset.mapId || "event-map")
    this.mq = typeof window.matchMedia === "function" ? window.matchMedia(COARSE_MQ) : null
    this.sync = () => {
      const show = Boolean(this.mq?.matches)
      this.el.hidden = !show
      if (this.mapEl) setMapTool(this.mapEl, show ? this.tool : null)
      if (show) syncPressed(this.el, this.tool)
    }
    this.onClick = (event) => {
      const btn = event.target && event.target.closest ? event.target.closest("[data-map-tool]") : null
      const next = btn && btn.dataset ? btn.dataset.mapTool : null
      if (!MAP_TOOLS.includes(next)) return
      this.tool = next
      syncPressed(this.el, this.tool)
      if (this.mapEl) setMapTool(this.mapEl, this.tool)
    }
    this.el.addEventListener("click", this.onClick)
    if (this.mq?.addEventListener) this.mq.addEventListener("change", this.sync)
    this.sync()
  },
  destroyed() {
    this.el.removeEventListener("click", this.onClick)
    if (this.mq?.removeEventListener) this.mq.removeEventListener("change", this.sync)
    if (this.mapEl) setMapTool(this.mapEl, null)
  },
}
